import { createContext, ReactNode, useContext } from "react";

import { appConfig } from "../../appConfig";
import { useAppContext } from "../../hooks/useAppContext";
import { useIdentityToken } from "../../hooks/useIdentityToken/useIdentityToken";
import type { RdmMessage } from "../../hooks/useSharedRdmWebsocket/rdmMessage.types";
import { useSharedRdmWebsocket } from "../../hooks/useSharedRdmWebsocket/useSharedRdmWebsocket";
import { isUnderDevelopment } from "../../utils/featureFlag";

export const RdmMessageContext = createContext<RdmMessage | null>(null);

export const RealtimeRdmProvider = ({ children }: { children: ReactNode }) => {
  const rdmEnabled = isUnderDevelopment(useAppContext());
  const token = useIdentityToken();
  const { lastMessage } = useSharedRdmWebsocket(
    appConfig.deviceApiWsUrl,
    rdmEnabled ? token : null,
  );

  return (
    <RdmMessageContext.Provider value={lastMessage}>
      {children}
    </RdmMessageContext.Provider>
  );
};

export function useRdmMessage(): RdmMessage | null {
  return useContext(RdmMessageContext);
}
